import React from 'react'
import Logo from '../../../static/media/logo.svg'

export const FooterLogo = () => <img alt="Rote Hilfe e.V." src={Logo} />
